import { Pipe, PipeTransform } from '@angular/core';

import { TipoDeIncidencia } from 'src/app/shared/enums/tiposIncidencias.enum';

@Pipe({
  name: 'incidenciasGraves'
})
export class IncidenciasGravesPipe implements PipeTransform {

  transform(lista: TipoDeIncidencia[], id: number): TipoDeIncidencia[] {

    return lista.filter(l => l.idInterno >= id);
  }

}
